<template>
  <div class="product-list">
    <el-card>
      <div slot="header" class="card-header">
        <div class="header-left">
          <span>商品管理</span>
          <el-tag v-if="brandUid" type="info" closable @close="clearBrandFilter" style="margin-left: 10px;">
            <i class="el-icon-price-tag" style="margin-right: 5px;"></i>
            品牌: {{ selectedBrandName }}
          </el-tag>
        </div>
        <div class="header-right">
          <el-input
            v-model="searchKey"
            placeholder="搜索商品名或PID"
            clearable
            style="width: 220px; margin-right: 10px;"
            @keyup.enter.native="handleSearch"
          ></el-input>
          <el-select
            v-model="brandUid"
            placeholder="选择品牌"
            clearable
            style="width: 150px; margin-right: 10px;"
            @change="handleSearch"
          >
            <el-option v-for="brand in allBrands" :key="brand.uid" :label="brand.nameCn" :value="brand.uid">
              <span>{{ brand.nameCn }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ brand.shortName }}</span>
            </el-option>
          </el-select>
          <el-button type="primary" size="small" @click="handleSearch">
            <i class="el-icon-search"></i>
            搜索
          </el-button>
          <el-button type="success" size="small" @click="handleAdd" style="margin-left: 10px;">
            <i class="el-icon-plus"></i>
            新增商品
          </el-button>
        </div>
      </div>
      <el-table :data="tableData" border stripe v-loading="loading">
        <el-table-column prop="pid" label="PID" width="150"></el-table-column>
        <el-table-column prop="productName" label="商品名称" width="200"></el-table-column>
        <el-table-column label="品牌" width="150">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.brand" type="success" size="small">
              {{ scope.row.brand.shortName || scope.row.brand.nameCn }}
            </el-tag>
            <span v-else style="color: #909399;">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="logo" label="商品图片" width="100">
          <template slot-scope="scope">
            <img v-if="scope.row.logo" :src="getImageUrl(scope.row.logo)" style="width: 60px; height: 60px; object-fit: contain;">
          </template>
        </el-table-column>
        <el-table-column prop="detail" label="商品描述" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="250" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleViewSpus(scope.row)">查看SPU</el-button>
            <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" @click="handleDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wrapper">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        ></el-pagination>
      </div>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="550px">
      <el-form :model="form" ref="form" label-width="100px">
        <el-form-item label="商品名称" prop="productName">
          <el-input v-model="form.productName" placeholder="请输入商品名称"></el-input>
        </el-form-item>
        <el-form-item label="品牌" prop="uid">
          <el-select v-model="form.uid" placeholder="请选择品牌" style="width: 100%;" clearable>
            <el-option v-for="brand in allBrands" :key="brand.uid" :label="brand.nameCn" :value="brand.uid">
              <span>{{ brand.nameCn }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ brand.shortName }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品图片" prop="logo">
          <el-input v-model="form.logo" placeholder="请输入图片URL"></el-input>
        </el-form-item>
        <el-form-item label="商品描述" prop="detail">
          <el-input type="textarea" v-model="form.detail" placeholder="请输入商品描述" :rows="4"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getImageUrl } from '@/utils/image'

export default {
  name: 'ProductList',
  data() {
    return {
      tableData: [],
      loading: false,
      searchKey: '',
      brandUid: null,
      selectedBrandName: '',
      dialogVisible: false,
      dialogTitle: '',
      form: {
        pid: null,
        productName: '',
        uid: null,
        logo: '',
        detail: ''
      },
      submitLoading: false,
      allBrands: [],
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  async mounted() {
    await this.loadBrands()
    // 检查路由参数
    if (this.$route.query.brandUid) {
      this.brandUid = this.$route.query.brandUid
      this.selectedBrandName = this.$route.query.brandName || ''
    }
    await this.loadData()
  },
  methods: {
    getImageUrl,
    async loadData() {
      this.loading = true
      try {
        const params = {
          pageNum: this.pagination.pageNum,
          pageSize: this.pagination.pageSize
        }
        if (this.searchKey) {
          params.searchKey = this.searchKey
        }
        if (this.brandUid) {
          params.uid = this.brandUid
        }
        const res = await this.$http.get('/productNew/page', { params })
        if (res.code === '200') {
          this.tableData = res.data.list || []
          this.pagination.total = res.data.total || 0
        }
      } catch (error) {
        this.$message.error('加载数据失败')
      } finally {
        this.loading = false
      }
    },
    async loadBrands() {
      try {
        const res = await this.$http.get('/brand/list')
        if (res.code === '200') {
          this.allBrands = res.data || []
        }
      } catch (error) {
        console.error('加载品牌失败', error)
      }
    },
    handleSearch() {
      this.pagination.pageNum = 1
      // 更新品牌名称显示
      if (this.brandUid) {
        const brand = this.allBrands.find(b => b.uid === this.brandUid)
        this.selectedBrandName = brand ? brand.nameCn : ''
      } else {
        this.selectedBrandName = ''
      }
      // 更新URL，保持同步
      const query = {}
      if (this.brandUid) {
        query.brandUid = this.brandUid
        query.brandName = this.selectedBrandName
      }
      this.$router.replace({ query }).catch(() => {})
      this.loadData()
    },
    clearBrandFilter() {
      this.brandUid = null
      this.selectedBrandName = ''
      this.handleSearch()
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.pagination.pageNum = val
      this.loadData()
    },
    handleAdd() {
      this.dialogTitle = '新增商品'
      this.form = { pid: null, productName: '', uid: null, logo: '', detail: '' }
      this.dialogVisible = true
    },
    handleEdit(row) {
      this.dialogTitle = '编辑商品'
      this.form = {
        pid: row.pid,
        productName: row.productName,
        uid: row.uid,
        logo: row.logo,
        detail: row.detail
      }
      this.dialogVisible = true
    },
    handleViewSpus(row) {
      this.$router.push({
        name: 'Spu',
        query: { pid: row.pid, productName: row.productName }
      })
    },
    handleDetail(row) {
      this.$message.info('查看商品详情功能开发中...')
    },
    async handleSubmit() {
      this.submitLoading = true
      try {
        const url = this.form.pid ? '/productNew/update' : '/productNew/add'
        const res = await this.$http.post(url, this.form)
        if (res.code === '200') {
          this.$message.success('操作成功')
          this.dialogVisible = false
          await this.loadData()
        } else {
          this.$message.error(res.msg || '操作失败')
        }
      } catch (error) {
        this.$message.error('操作失败')
      } finally {
        this.submitLoading = false
      }
    }
  }
}
</script>

<style scoped>
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  display: flex;
  align-items: center;
}

.header-right {
  display: flex;
  align-items: center;
}

.pagination-wrapper {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
</style>
